import React, { useEffect, useState } from "react";
import "react-sliding-pane/dist/react-sliding-pane.css";
import "jspdf-autotable";

import AllReciptReport from "./AllReceiptReport";
import UnappliedReciptReport from "./UnappliedReceiptsReport";

function ReciptReport({ id, setReceiptview }) {
	const [loading, setLoading] = useState(true);
	const [viewReceipts, setviewReceipts] = useState("unappliedreceipts");
	const [receipts, setReceipt] = useState(false);
	const [unappliedreceipts, setUnappliedreceipts] = useState(false);

	useEffect(() => {
		setLoading(false);
	}, []);


	useEffect(() => {
		viewReceipts === "receipt" ? setReceipt(true) : setReceipt(false);
		viewReceipts === "unappliedreceipts"
			? setUnappliedreceipts(true)
			: setUnappliedreceipts(false);
	}, [viewReceipts]);

	useEffect(() => {
		setviewReceipts(setReceiptview)
	}, [setReceiptview]);

	return (
		<>
			<div className="content container-fluid">
				<div value={viewReceipts} className="pt-1">
				</div>
				<div className="body py-2">
					<div className="col-md-12">
						{receipts && <AllReciptReport />}
						{unappliedreceipts && <UnappliedReciptReport />}
					</div>
				</div>
			</div>
		</>
	);
}

export default ReciptReport;
